export const hasDuplicates = (array: (string | number)[]) => {
  return new Set(array).size !== array.length;
};

/**
 * deduplicate string or number array
 * @param elements
 * @returns
 */
export const deduplicateSimples = (elements: (string | number)[]) => {
  return Array.from(new Set(elements));
};
